import { render, staticRenderFns } from "./UserE_Details.vue?vue&type=template&id=0beca98d"
import script from "./UserE_Details.vue?vue&type=script&lang=js"
export * from "./UserE_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports